export default {
  name: 'Aswitch',
  props: {
    label: { type: String, default: () => '' },
    value: { type: Number | String | Boolean, default: () => null },
    disabled: { type: Boolean, default: () => false },
    width: { type: Number, default: () => 40 },
    activeIconClass: { type: String, default: () => '' },
    inactiveIconClass: { type: String, default: () => '' },
    activeText: { type: String, default: () => '开' },
    inactiveText: { type: String, default: () => '关' },
    activeValue: { type: Number, default: () => 1 },
    inactiveValue: { type: Number, default: () => 0 },
    activeColor: { type: String, default: () => '#13ce66' },
    inactiveColor: { type: String, default: () => '' },
    name: { type: String, default: () => '' },
    validateEvent: { type: Boolean, default: () => false },
  },
  data() {
    return {
      model: 0,
    }
  },
  watch: {
    value() {
      this.create();
    }
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      this.model = this.value;
    },
    change(value) {
      this.$emit('change', value);
    },
    focus() {
      this.$emit('focus');
    },
  },
  render() {
    // eslint-disable-next-line no-unused-vars
    const { value, ...attrs } = this.$attrs;
    return (
      <div style={{ ...attrs.style }}>
        {this.label != '' && <span>{this.label}&emsp;</span>}
        <span>
          <el-switch
            v-model={this.model}
            disabled={this.disabled}
            width={this.width}
            active-icon-class={this.activeIconClass}
            inactive-icon-class={this.inactiveIconClass}
            active-text={this.activeText}
            inactive-text={this.inactiveText}
            active-value={this.activeValue}
            inactive-value={this.inactiveValue}
            active-color={this.activeColor}
            inactive-color={this.inactiveColor}
            name={this.name}
            validate-event={this.validateEvent}
            on-change={e => this.change(e)}
            on-focus={e => this.focus(e)}
            {...{ attrs }}
          />
        </span>
      </div>
    );
  }
}